module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-shenzhen.c0d05778.jpg";